import API from "./api";
const Service = {
    get: () => {
        return new Promise((resolve, reject) => {
            API.get('feedback').then(
                info => {
                    resolve(info)
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    update: (item) => {
        return new Promise((resolve, reject) => {
            API.post('feedback' , null, {item:item}).then(
                result => {
                    resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    deleteItem: (id) => {
        return new Promise((resolve, reject) => {
            API.deleteItem('feedback/'+id ).then(
                result => {
                    resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    }
}
export default Service;